"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setOpen = exports.cancelAbility = exports.get = void 0;
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var spritesUi_1 = require("@dive/spriteRecyclers/spritesUi");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveSimulationDirector_sidecar_1 = require("@dive/simulation/diveSimulationDirector-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var diveMessage_mouseInput_1 = require("@voyage/multi/diveMessage_mouseInput");
var diveMessage_mouseInput_sidecar_1 = require("@voyage/multi/diveMessage_mouseInput-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var diveUi_mouseUtils_1 = require("./diveUi_mouseUtils");
var diveUi_mouseUtils_sidecar_1 = require("./diveUi_mouseUtils-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(true);
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var obj = {
        isOpen: true,
        selectedIdx: 0,
    };
    return obj;
};
function cancelAbility() {
    var obj = get();
    obj.selectedIdx = 0;
    voyagePicker_sidecar_1.voyagePicker.setCursorMode('normal');
}
exports.cancelAbility = cancelAbility;
var setOpen = function (isOpen) {
    var obj = get();
    obj.isOpen = isOpen;
};
exports.setOpen = setOpen;
var update = function () {
    var _a;
    var obj = get();
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var x = gb.width / 2 - 200 - 100;
    var y = gb.height - 100;
    // Render basic level info
    var gameInfoXo = -400;
    var gameInfoYo = -30;
    diveFont_sidecar_1.diveFont.writeAbsolute(x + gameInfoXo, y + gameInfoYo, 'Hello MP Test! ', 0.5);
    // Render basic level info
    var levelInfoXo = -220;
    var levelInfoYo = -30;
    diveFont_sidecar_1.diveFont.writeAbsolute(x + levelInfoXo, y + levelInfoYo, 'Level ' + diveSimulationDirector_sidecar_1.diveSimulationDirector.get().levelNum, 0.5);
    if (diveSimulationDirector_sidecar_1.diveSimulationDirector.get().isSafeRoom) {
        diveFont_sidecar_1.diveFont.writeAbsolute(x + levelInfoXo, y + levelInfoYo + 20, 'Safe Room', 0.5);
    }
    // Get our selected character
    var cr = voyagePicker_sidecar_1.voyagePicker.get().selectedCrew;
    if (!cr) {
        return;
    }
    // Render basic info
    var infoXo = -20;
    var infoYo = -30;
    diveFont_sidecar_1.diveFont.writeAbsolute(x + infoXo, y + infoYo, cr.name, 0.5);
    infoYo += 20;
    var title = ((_a = cr.heroState) === null || _a === void 0 ? void 0 : _a.data.name) || cr.title;
    diveFont_sidecar_1.diveFont.writeAbsolute(x + infoXo, y + infoYo, title, 0.5);
    infoYo += 20;
    diveFont_sidecar_1.diveFont.writeAbsolute(x + infoXo, y + infoYo, cr.hitpoints + ' hp', 0.5);
    infoYo += 40;
    diveFont_sidecar_1.diveFont.writeAbsolute(x + infoXo, y + infoYo, cr.info1, 0.5);
    x += 200;
    // Collect our abilities
    var abilities = [];
    abilities.push({
        name: 'Move',
        inputHint: diveMessage_mouseInput_1.EDiveInputHint.CancelAbility,
        frame: sprites_sidecar_1.sprites.diveEffectsAbilityMove,
    });
    abilities.push({
        name: 'Weapon',
        inputHint: diveMessage_mouseInput_1.EDiveInputHint.Null,
        inputHintAlt: diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropWeapon,
        displayText: 'Weapon',
        frame: [],
        render: function (x, y) {
            if (cr === null || cr === void 0 ? void 0 : cr.weaponSlot) {
                diveObjects_sidecar_1.diveObjects.renderAt(cr.weaponSlot, spritesUi_1.spritesUi, x, y);
            }
        },
    });
    if (cr && cr.type === diveCrew_1.EVoyageCrewType.Hero) {
        if (cr.heroType === diveCrew_hero_data_1.EDiveHeroSubtype.Wizard) {
            if (cr.weaponSlot) {
                if (cr.weaponSlot.data.maxAbility1Uses) {
                    abilities.push({
                        name: 'Fireball',
                        inputHint: diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_firewall,
                        frame: sprites_sidecar_1.sprites.diveEffectsFire,
                        displayNum: '' + cr.weaponSlot.ability1Uses,
                    });
                }
                if (cr.weaponSlot.data.maxAbility2Uses) {
                    abilities.push({
                        name: 'Lightning Cloud',
                        inputHint: diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_lightningCloud,
                        frame: sprites_sidecar_1.sprites.diveEffectsWeeFxLightning1Png,
                        displayNum: '' + cr.weaponSlot.ability2Uses,
                    });
                }
            }
        }
    }
    while (abilities.length < 4) {
        abilities.push({
            name: 'Null',
            inputHint: diveMessage_mouseInput_1.EDiveInputHint.Null,
            frame: [],
        });
    }
    // let itemFrame: ISPD[] = []
    // if (cr.itemSlot1) {
    //   itemFrame = cr.itemSlot1.data.frames
    // }
    abilities.push({
        name: 'Item',
        displayText: 'Item',
        inputHint: diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_useItem,
        inputHintAlt: diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropItem,
        // frame: itemFrame,
        frame: [],
        render: function (x, y) {
            if (cr === null || cr === void 0 ? void 0 : cr.itemSlot1) {
                diveObjects_sidecar_1.diveObjects.renderAt(cr.itemSlot1, spritesUi_1.spritesUi, x, y);
            }
        },
    });
    abilities.push({
        name: 'Loot',
        displayText: 'Loot',
        inputHint: diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropLoot,
        inputHintAlt: diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropLoot,
        frame: [],
        render: function (x, y) {
            if (cr === null || cr === void 0 ? void 0 : cr.lootSlot1) {
                diveObjects_sidecar_1.diveObjects.renderAt(cr.lootSlot1, spritesUi_1.spritesUi, x, y);
            }
        },
    });
    // Render each of our abilities
    if (obj.selectedIdx >= abilities.length) {
        obj.selectedIdx = 0;
        diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
            hint: diveMessage_mouseInput_1.EDiveInputHint.CancelAbility,
            frame: 0,
            centerOn: false,
            targetId: 0,
            fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
            tx: 0,
            ty: 0,
        });
    }
    for (var i = 0; i < abilities.length; i++) {
        var c = abilities[i];
        var isSelected = i === obj.selectedIdx;
        var img = spritesUi_1.spritesUi.getNext(x, y, sprites_sidecar_1.sprites.diveEffectsBoxAbility[0]);
        var hit = diveUi_mouseUtils_sidecar_1.diveUi_mouseUtils.hitTest(img);
        if (isSelected) {
            spritesUi_1.spritesUi.changeImageFrame(img, sprites_sidecar_1.sprites.diveEffectsBoxAbilityCurrent[0]);
        }
        var sendHint = function (hint) {
            var targetId = 0;
            if (hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropLoot ||
                hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropItem ||
                hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_useItem ||
                hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropWeapon) {
                targetId = (cr === null || cr === void 0 ? void 0 : cr.id) || 0;
            }
            diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
                hint: hint,
                frame: 0,
                centerOn: false,
                targetId: targetId,
                fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
                tx: 0,
                ty: 0,
            });
        };
        if (hit === diveUi_mouseUtils_1.EHitTest.LeftFirstDown) {
            obj.selectedIdx = i;
            // Clicked ability
            sendHint(c.inputHint);
        }
        if (hit === diveUi_mouseUtils_1.EHitTest.RightFirstDown && c.inputHintAlt) {
            // obj.selectedIdx = i
            // Right-clicked ability (alt)
            sendHint(c.inputHintAlt);
        }
        if (!isSelected) {
            if (hit === diveUi_mouseUtils_1.EHitTest.Over ||
                hit === diveUi_mouseUtils_1.EHitTest.LeftHeldDown ||
                hit === diveUi_mouseUtils_1.EHitTest.LeftFirstDown) {
                spritesUi_1.spritesUi.changeImageFrame(img, sprites_sidecar_1.sprites.diveEffectsBoxAbilityHover[0]);
            }
        }
        if (c.frame.length > 0) {
            spritesUi_1.spritesUi.getNext(x, y, c.frame[0]);
        }
        if (c.render) {
            c.render(x, y);
        }
        if (c.displayText) {
            diveFont_sidecar_1.diveFont.writeAbsolute(x - 20, y - 30, c.displayText, 0.5);
        }
        if (c.displayNum) {
            diveFont_sidecar_1.diveFont.writeAbsolute(x - 20, y + 32, '' + c.displayNum, 0.5);
        }
        x += 50;
    }
};
exports.update = update;
// export const render = () => {
//   let obj = get()
//   let g = obj.graphics
//   voyageUiCanvas.clear(obj)
//   let gb = voyageCamera.getGameBounds()
//   let x = gb.width - 200
//   let y = 20
//   let w = 500
//   let h = 300
//   let sy = y
//   let sx = x
//   let addText = (text: string, ox: number = 0, oy: number = 0) => {
//     let t = voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3)
//     stevieTexts2.setWrapWidth(t, w - 60)
//     y += 20
//     return t
//   }
//   let addSpacer = () => {
//     y += 30
//   }
//   addText(
//     websockets.getConnectionStatus() +
//       ' ' +
//       (voyageWebsockets.getIsHost() ? 'Host' : 'Client'),
//   )
//   addText('Game: ' + websockets.getChannel())
//   addText(
//     'Id: ' +
//       voyageWebsockets.getMultiId() +
//       ' - ' +
//       voyageWebsockets.getMultiName(),
//   )
//   addText('Ping: ' + voyageWebsockets.getPingTime() + ' ms')
//   voyageUiCanvas.render(obj)
// }
